import React, { useState } from "react";
import { toast } from "sonner";
import axiosInstance from "../../utility/axiosInstance";
import { useSearchParams } from "react-router-dom";
import TextInputBox from "../../components/elements/forms/TextInputBox";
import PageLayout from "../../components/Layout/PageLayout";

const Suggestions = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("Id");
  // suggestions / feedbacks
  const [showSuggestion, setShowSuggestion] = useState(true);
  const [suggestion, setSuggestion] = useState("");
  // const [suggestionAmount, setSuggestionAmount] = useState("");
  const [suggestionFile, setSuggestionFile] = useState<File | null>(null);
  const [submittingSuggestion, setSubmittingSuggestion] = useState(false);

  const handleSubmitSuggestion = async () => {
    if (!suggestion.trim()) {
      toast.error("Please enter a suggestion");
      return;
    }

    try {
      setSubmittingSuggestion(true);
      
      const formData = new FormData();
      formData.append("suggestion", suggestion);
      // if (suggestionAmount) {
      //   formData.append("amount", suggestionAmount);
      // }
      if (suggestionFile) {
        formData.append("upload", suggestionFile);
      }

      await axiosInstance.post(`/organizations/${id}/suggestions`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Thank you for your suggestion!");
      setSuggestion("");
      // setSuggestionAmount("");
      setSuggestionFile(null);
      setShowSuggestion(false);
    } catch (error) {
      console.error("Error submitting suggestion:", error);
      toast.error("Failed to submit suggestion");
    } finally {
      setSubmittingSuggestion(false);
    }
  };
  return (
    <PageLayout className="min-h-screen">
      <div className="max-w-5xl mx-auto pt-10 pb-20 h-full">
        <button
          // onClick={() => setShowSuggestion(!showSuggestion)}
          className="text-black text-[16px] font-medium flex items-center justify-center gap-1"
        >
          Require a different feature, or have feedback?
        </button>

        {showSuggestion && (
          <div className="mt-2 p-6 bg-white rounded-[15px] border border-gray-200">
            <TextInputBox
              label="Feature Suggestion"
              placeholder="Tell us what feature you would like to see..."
              name="suggestion"
              value={suggestion}
              onChange={(e) => setSuggestion(e.target.value)}
              rows={4}
            />
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
                <input
                  type="number"
                  value={suggestionAmount}
                  onChange={(e) => setSuggestionAmount(e.target.value)}
                  placeholder="E.g., 78"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors"
                />
              </div> */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Upload File (Optional)</label>
                <input
                  type="file"
                  onChange={(e) => setSuggestionFile(e.target.files?.[0] || null)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-colors file:mr-4 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-primary file:text-white hover:file:bg-primary/90"
                />
              </div>
            </div>
            <div className="flex justify-start mt-4">
              <button
                onClick={handleSubmitSuggestion}
                disabled={submittingSuggestion}
                className={`py-2 px-6 rounded-lg text-white font-medium transition-all ${
                  submittingSuggestion
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-primary hover:bg-blue-700"
                }`}
              >
                {submittingSuggestion ? "Submitting..." : "Submit Suggestion"}
              </button>
            </div>
          </div>
        )}
      </div>
    </PageLayout>
  );
};

export default Suggestions;
